import {
  Component,
  OnInit,
  ViewEncapsulation,
  ChangeDetectionStrategy,
  Input,
  ChangeDetectorRef,
  Output, EventEmitter
} from '@angular/core';
import { MediaCell } from '../../carousel-media-cell/carousel-media-cell.component';

@Component({
  selector: 'lib-pdf-wrapper',
  templateUrl: './pdf-wrapper.component.html',
  styleUrls: ['./pdf-wrapper.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PdfWrapperComponent {
  @Output() isLoadingEmitter: EventEmitter<boolean> = new EventEmitter();
  @Input() objectFit: string = '';
  @Input()
  get pdf(): MediaCell { return this._pdf }
  set pdf(val: MediaCell) {
    this._pdf.src = val.src;
    this._pdf.type = val.type;
  }
  private _pdf: MediaCell = { src: '', loading: true, type: '' };
  constructor(private cd: ChangeDetectorRef) { }
  ngOnInit() {
    this.isLoadingEmitter?.emit(true)
  }
  ngAfterViewInit() {
    this.cd.markForCheck();
  }

  pdfRenderedEvent(e: any, pdf: MediaCell): void {
    pdf.thumbnail = e.source.canvas.toDataURL();
    pdf.loading = false;
    this.isLoadingEmitter?.emit(false);
  }

}
